import { render, staticRenderFns } from "./ThankTile.vue?vue&type=template&id=730a8b5e&"
import script from "./ThankTile.vue?vue&type=script&lang=js&"
export * from "./ThankTile.vue?vue&type=script&lang=js&"
import style0 from "./ThankTile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports